const ITEMS = [
  "Aged Data",
  "Web Scraping",
  "Data Appending",
  "Speed-to-Lead",
  "Google Ads",
  "Meta Marketing",
  "CRM Automation",
  "Conversion Tracking",
  "Lead Routing",
  "Multi-Touch Follow-Up",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="rsm-marquee-wrap relative overflow-hidden border-y border-white/10 bg-[#0b0f17] py-6"
    >
      <div className="rsm-marquee-track gap-10">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-lg sm:text-2xl font-bold text-slate-200 whitespace-nowrap">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400 shrink-0" />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0b0f17] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0b0f17] to-transparent" />
    </div>
  );
}
